import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const title: ThemeUICSSObject = {
  /* PREPEND HERE */
};

export default title;
